import React from 'react'
import { Table } from 'react-bootstrap'

function ProjectHeader() {
  return (
    <div style={{"display":'flex',"justifyContent":'space-around'}}>
        {/* <Table bordered>
        <thead>
            <tr>
            <th> <h6>ProjectName</h6> </th>
        <th><h6>Customer Name</h6></th>
       <th> <h6>Skill Set</h6></th>
       <th><h6>Tools&Technologies</h6></th> 
        <th><h6>Responsibilities</h6></th>
        <th><h6>Duration</h6></th>
        </tr>
        </thead>
        </Table> */}
    </div>
  )
}

export default ProjectHeader